import { TFunction } from '@lyearn/i18n';
import { getIsQuizInProgress } from '@/modules/corporate/modules/quiz/utils';
import { QuizDetailsContentFragment } from '@/modules/corporate/modules/quiz/views/QuizDetails/graphql/fragments/generated/QuizDetailsContent';
import { QuizDetailsPerformanceFragment } from '@/modules/corporate/modules/quiz/views/QuizDetails/graphql/fragments/generated/QuizDetailsPerformance';
import { getCanRetakeQuiz } from '@/modules/corporate/modules/quiz/views/QuizDetails/utils/getCanRetakeQuiz';
import getQuizModifiedAttempts from '@/modules/corporate/modules/quiz/views/QuizDetails/utils/getQuizModifiedAttempts';
import { QuizResultEnum } from '@/types/schema';

export const getPrimaryActionLabel = (
  t: TFunction,
  quiz: QuizDetailsContentFragment,
  quizPerformance?: QuizDetailsPerformanceFragment,
  isAICourseBuilder?: boolean,
) => {
  const attemptsCount = getQuizModifiedAttempts(quizPerformance).length;
  const canRetakeQuiz = attemptsCount >= 1 && getCanRetakeQuiz(quiz, quizPerformance).canRetakeQuiz;
  const isQuizInProgress = getIsQuizInProgress(quizPerformance);

  if (isAICourseBuilder) {
    return t('QuizPlayer:ViewQuiz');
  }

  if (isQuizInProgress) {
    return t('QuizPlayer:ResumeQuiz');
  }

  if (quizPerformance?.result !== QuizResultEnum.Pass && canRetakeQuiz) {
    return t('QuizPlayer:ReAttemptQuiz');
  }

  if (attemptsCount == 0) {
    return t('Common:ContentCards.StartQuiz');
  }

  return null;
};
